import { render, staticRenderFns } from "./PhoneValidation.vue?vue&type=template&id=6e7d598d"
import script from "./PhoneValidation.vue?vue&type=script&lang=js"
export * from "./PhoneValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports